import React, {useCallback, useEffect, useState} from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {BooleanInput, LongTextInput, required, Title} from 'react-admin';
import {NotifyForm, showErrorNotify} from '../../components';
import env from '../../env';
import moment from "moment";
import {downloadFilePost} from "../../components/FileDownload";
import TreeCheckBoxCustomInput from "../../components/TreeCheckBoxCustomInput";
import utils from "../../utils/utils";
import axiosInstance from "../../api/axios";
import {MonthInput} from "../../components/MonthInput";

const UnpaidBillNotify = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [customers, setCustomers] = useState([]);

    const [params, setParams] = useState({
        displayDept: true,
        fromMonth: moment().format('YYYY-MM'),
        toMonth: moment().format('YYYY-MM'),
        customerIds: [],
        note: '',
        unitIds: [],
    });

    // ---------------------------
    // Load Students
    // ---------------------------
    useEffect(() => {
        axiosInstance
            .get('/api/customersByUnits?studentOnly=true')
            .then(rs => setCustomers(rs.data.content || []));
    }, []);

    // ---------------------------
    // Generate Report URL (GET)
    // ---------------------------
    const notifyAllStudentsUrl = useCallback((type, fullDayOnly, allStudent) => {
        return `${env.baseURL}/reports/unpaidBillNotify?` +
            `&note=${params.note || ''}` +
            `&fullDayOnly=${fullDayOnly}` +
            `&allStudent=${allStudent}` +
            `&displayDept=${params.displayDept}` +
            `&fromMonth=${params.fromMonth}` +
            `&toMonth=${params.toMonth}` +
            `&pUnitIds=${params.unitIds}`;
    }, [params]);

    // ---------------------------
    // POST download report
    // ---------------------------
    const getReportUrl = useCallback((fullDay, allStudent) => {
        if (!params.note) params.note = '';

        setIsLoading(true);
        const data = {
            fullDayOnly: fullDay,
            allStudent: allStudent,
            displayDept: params.displayDept,
            note: params.note,
            fromMonth: params.fromMonth,
            toMonth: params.toMonth,
            customerIds: params.customerIds
        };

        downloadFilePost(`${env.baseURL}/reports/unpaidBillNotify`, 'thong_bao_hoc_phi.xlsx', data)
            .finally(() => setIsLoading(false));
    }, [params]);

    // ---------------------------
    // User Actions
    // ---------------------------
    const notifyAllStudents = useCallback(() => {
        if (!params.customerIds?.length) {
            showErrorNotify("Vui lòng chọn danh sách học sinh");
            return;
        }
        getReportUrl(false, true);
    }, [params, getReportUrl]);

    const fullDayOnly = useCallback(() => {
        if (!params.customerIds?.length) {
            showErrorNotify("Vui lòng chọn danh sách học sinh");
            return;
        }
        getReportUrl(true, false);
    }, [params, getReportUrl]);

    const notFullDayOnly = useCallback(() => {
        if (!params.customerIds?.length) {
            showErrorNotify("Vui lòng chọn danh sách học sinh");
            return;
        }
        getReportUrl(false, false);
    }, [params, getReportUrl]);

    // ---------------------------
    // Validate for NotifyForm
    // ---------------------------
    const validate = (values) => {
        setParams(prev => ({...prev, ...values}));
        return {};
    };

    return (
        <Card>
            <Title title="resources.unpaidBillNotify.name"/>
            <CardContent>
                <p>Dữ liệu nợ tính theo ngày bắt đầu kế hoạch thuộc "Từ tháng" "Đến tháng" được chọn</p>
                <NotifyForm
                    validate={validate}
                    allClazzes={notifyAllStudents}
                    fullDayClazzes={fullDayOnly}
                    notFullDayClazzes={notFullDayOnly}
                    params={params}
                    isLoading={isLoading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={3}>
                            <MonthInput
                                label="Từ tháng"
                                source="fromMonth"
                                validate={required()}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <MonthInput
                                label="Đến tháng"
                                source="toMonth"
                                validate={required()}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <BooleanInput
                                label="resources.unpaidBillNotify.displayDept"
                                source="displayDept"
                                {...props}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <LongTextInput
                                label="resources.unpaidBillNotify.note"
                                rows={5}
                                multiline
                                source="note"
                                {...props}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <label><b>Danh sách học sinh</b></label>
                            <div style={{width: 500, maxHeight: '300px', overflow: 'auto', marginTop: 10}}>
                                <TreeCheckBoxCustomInput
                                    data={customers}
                                    expandTopLevel={true}
                                    onChange={(value) =>
                                        setParams(prev => ({
                                            ...prev,
                                            customerIds: utils.extractCustomerIdsV2(value)
                                        }))
                                    }
                                />
                            </div>
                        </Grid>
                    </Grid>
                </NotifyForm>
            </CardContent>
        </Card>
    );
};

export default UnpaidBillNotify;
